import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Program } from 'utils';

type ReturnType = Promise<AxiosResponse<Program>>;

const viewProgram = (id: string): ReturnType => {
    return Request.get(`/workouts/programs/${id}`);
};

export default viewProgram;
